// Centralized Call For Papers page content for different WCHSS years.

export const papersContent2026 = {
  title: 'Call For Papers',
  introParagraphs: [
    'All researchers, academics, practitioners, and students are invited to contribute and participate in WCHSS 2026 by submitting original research papers and abstracts related to health and social sciences across the human life cycle.',
    'The conference welcomes interdisciplinary, empirical, conceptual, and evidence-based studies that address biological, psychological, social, environmental, and technological dimensions of health and wellbeing.',
    'All submitted papers will undergo a peer-review process and selected papers will be considered for publication in indexed proceedings and journals.',
  ],
  tracksTitle: 'Conference Tracks',
  tracksIntro: 'The topics of papers cover but are not limited to:',
  topics: [
    'Maternal and Reproductive Health',
    'Early Childhood Development',
    'Adolescent Health and Wellbeing',
    'Adult and Occupational Health',
    'Healthy Aging and Geriatrics',
    'Mental Health and Psychosocial Wellbeing',
    'Community and Public Health',
    'Social Determinants of Health',
    'Health Policy and Health Systems',
    'Digital Health and Telemedicine',
    'Nutrition and Lifestyle Medicine',
    'Environmental and Global Health',
    'Nursing and Midwifery Innovation',
    'Social Welfare and Community Empowerment',
    'Interdisciplinary Health and Social Science Research',
  ],
  submitSection: {
    title: 'Submit Abstract / Paper',
    abstractLabel: 'Abstract Template (WCHSS 2026)',
    fullPaperLabel: 'Full-Paper Template (WCHSS 2026)',
    abstractLink: '',
    fullPaperLink: '',
  },
};
